import styled from "styled-components";

export const Title = styled("h4")`
  font-weight: 500;
  color: #454545;
  letter-spacing: 0.05em;
`;